import { ApolloError } from "@apollo/client";
import ErrorBox from "../components/ErrorBox";

const HandleApolloError = (errorType: string, error: ApolloError) => {
	let ret = [];
	if (error.graphQLErrors) {
		console.log(`[GraphQL error]: ${error.message}`);
		for (let err of error.graphQLErrors) {
			ret.push(<ErrorBox errorType={errorType} errorMessage={String(err.extensions?.code)} errorDetail={error.message} />);
		}
	}
	if (error.networkError) {
		console.log(`[Network error]: ${error.networkError}`);
		ret.push(<ErrorBox errorType={errorType} errorMessage="Network Error" errorDetail={JSON.stringify(error.networkError)} />);
	}

	return ret;
};

export default HandleApolloError;
